import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Pagination,
  PaginationItem,
  PaginationLink
} from 'reactstrap';
import moment from 'moment';
import { Link } from "react-router-dom";
import { IMAGE } from "common-import/constants";
import { inject, observer } from "mobx-react"
import { VarHelper } from "common-import/helpers";


@inject("userStore") @observer
class UserList extends Component {

  state = {
    page: 1,
  }

  async componentDidMount() {
    // let result = await this.props.userStore.adminList({
    //   "orderBy": "updatedAt",
    //   "orderType": "DESC",
    //   "page": 1,
    // });
    // console.log(result);
    await this.props.userStore.onReady();
    this.getList(this.state.page);
  }

  getList = async page => {
    let result = await this.props.userStore.adminList({
      "orderBy": "updatedAt",
      "orderType": "DESC",
      "page": page,
    });
  }

  loadPrev = e => {
    !!e && e.preventDefault();
    if(this.state.page === 1) return;
    const { userStore } = this.props;
    this.setState({ page: this.state.page === 1 ? 1 : this.state.page - 1}, () => {
      this.getList(this.state.page);
    });
  }

  loadNext = e => {
    !!e && e.preventDefault();
    const { userStore } = this.props;
    this.setState({ page: this.state.page + 1}, () => {
      this.getList(this.state.page);
    });
  }

  renderRow(data, index) {
    return (
      <tr key={"listuser" + index}>
        <td className="text-center">
          <div className="avatar">
            <img src={!!data.avatar ? VarHelper.img(data.avatar) : IMAGE} className="img-avatar" alt="admin@bootstrapmaster.com" />
            {/* <span className="avatar-status badge-success"></span> */}
          </div>
        </td>
        <td>
          <Link to={`/user/${data.id}`}>
            <div>{data.name}</div>
            <div className="small text-muted">
              <span>Email</span>: {data.email}
            </div>
          </Link>
        </td>
        <td>
          <div className="clearfix">
            <div className="float-left">
              <strong>{data.tel}</strong>
            </div>
          </div>
        </td>
        <td>
          <div className="clearfix">
            <div className="float-left">
              <strong>{data.jobTitle}</strong>
            </div>
          </div>
        </td>
        <td>
          <div className="small text-muted">{data.type}</div>
          <strong>{data.isAdmin ? "Admin" : ""}</strong>
        </td>
      </tr>

    )
  }

  render() {

    return (
      <div className="animated fadeIn">
        {/* <FormGroup row>
          <Col md="12">
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <Button type="button" color="primary"><i className="fa fa-search"></i> Search</Button>
              </InputGroupAddon>
              <Input type="text" id="input1-group2" name="input1-group2" placeholder="Username"/>
            </InputGroup>
          </Col>
        </FormGroup> */}
        <Row>
          <Col xs="12" sm="12">
            <Table hover responsive className="table-outline mb-0 d-sm-table">
              <thead className="thead-light">
                <tr>
                  <th className="text-center"><i className="icon-people"></i></th>
                  <th>User</th>
                  <th>Telephone</th>
                  <th>Job title</th>
                  <th>Type</th>
                </tr>
              </thead>
              <tbody style={{ backgroundColor: 'white' }}>
                {this.props.userStore.listUser.slice().map((val, index) => this.renderRow({
                  name: val.name,
                  email: val.email,
                  tel: val.phone,
                  jobTitle: "",
                  type: !!val.type ? val.type[0] : '',
                  isAdmin: val.isSuperAdmin || false,
                  avatar: val.avatar,
                  id: val.id,
                }, index))}
                {/* {this.renderRow({
                    name: "Nguyễn Văn A",
                    email: "nguyenvana@gmail.com",
                    tel: "0912345678",
                    jobTitle: "Manager",
                    type: "Contractor",
                    isAdmin: false
                  })}
                  {this.renderRow({
                    name: "Nguyễn Văn A",
                    email: "nguyenvana@gmail.com",
                    tel: "0912345678",
                    jobTitle: "Manager",
                    type: "Project Owner",
                    isAdmin: true
                  })}
                  {this.renderRow({
                    name: "Nguyễn Văn A",
                    email: "nguyenvana@gmail.com",
                    tel: "0912345678",
                    jobTitle: "Manager",
                    type: "Contractor",
                    isAdmin: true
                  })}
                  {this.renderRow({
                    name: "Nguyễn Văn A",
                    email: "nguyenvana@gmail.com",
                    tel: "0912345678",
                    jobTitle: "Manager",
                    type: "Project Owner",
                    isAdmin: false
                  })} */}
              </tbody>
            </Table>

          </Col>
        </Row>
        <Row style={{ marginTop: 20, marginBottom: 20 }}>
          <Col xs="12" md="12">
            <Pagination>
              <PaginationItem>
                <PaginationLink previous onClick={this.loadPrev} />
              </PaginationItem>
              <PaginationItem>
                <PaginationLink>{this.state.page}</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink next onClick={this.loadNext} />
              </PaginationItem>
            </Pagination>
          </Col>
        </Row>
      </div>
    );
  }
}

export default UserList;


// WEBPACK FOOTER //
// ./src/views/Users/UserList.js